var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8b95a5",
    d: "M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.045-4.152-.068-8.147-13.59 2.955-16.459-6.548-16.459-6.548-2.223-5.65-5.428-7.15-5.428-7.15-4.436-3.031.34-2.969.34-2.969 4.906.35 7.487 5.038 7.487 5.038 4.36 7.465 11.443 5.311 14.229 4.063.44-3.158 1.707-5.312 3.106-6.53-10.85-1.23-22.257-5.437-22.257-24.198 0-5.345 1.913-9.716 5.045-13.14-.507-1.229-2.186-6.212.478-12.958 0 0 4.11-1.316 13.469 5.02a46.899 46.899 0 0 1 12.26-1.647c4.161.019 8.354.564 12.26 1.646 9.354-6.335 13.462-5.019 13.462-5.019 2.669 6.746.988 11.73.482 12.958 3.14 3.425 5.043 7.796 5.043 13.14 0 18.81-11.427 22.955-22.317 24.16 1.756 1.51 3.319 4.492 3.319 9.049 0 6.535-.06 11.808-.06 13.412 0 1.313.885 2.85 3.339 2.363C81.017 89.373 95 70.966 95 49.217 95 22 73.146 0 48.854 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.437bb4a13f396411255b613c51c2d846.svg";
export { ForwardRef as ReactComponent };